// extracted by mini-css-extract-plugin
export default {"radio-wrap":"Radio_radio-wrap__f4mU3","radio":"Radio_radio__Ct-rH"};